<template>
  <div class="min-h-screen bg-gradient-to-br from-psychology-calm via-white to-psychology-warm">
    <!-- 背景装饰 -->
    <div class="absolute inset-0 pointer-events-none overflow-hidden">
      <div class="absolute top-20 left-10 w-16 h-16 sm:w-24 sm:h-24 md:w-32 md:h-32 bg-psychology-primary-20 rounded-full blur-xl"></div>
      <div class="absolute top-40 right-16 w-12 h-12 sm:w-20 sm:h-20 md:w-24 md:h-24 bg-psychology-warning-20 rounded-full blur-lg"></div>
      <div class="absolute bottom-32 left-1/3 w-20 h-20 sm:w-32 sm:h-32 md:w-40 md:h-40 bg-psychology-accent-20 rounded-full blur-xl"></div>
    </div>

    <!-- 导航栏 -->
    <NavBar />

    <!-- 主要内容 -->
    <div class="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 md:py-12">
      <!-- 页面标题 -->
      <div class="text-center mb-8 sm:mb-10 md:mb-12">
        <div class="text-4xl sm:text-5xl md:text-6xl mb-4 sm:mb-5 md:mb-6">🎯</div>
        <h1 class="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">使用指南</h1>
        <p class="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl mx-auto px-2">
          通过90道科学问题，了解你的职业兴趣类型和Holland Code
        </p>
      </div>

      <div class="space-y-6 sm:space-y-8">
        <!-- 快速开始 -->
        <div class="card">
          <div class="p-4 sm:p-5 md:p-6">
            <div class="text-xl sm:text-2xl font-semibold flex items-center gap-2 sm:gap-3 mb-4 sm:mb-5 md:mb-6">
              <span class="text-2xl sm:text-3xl">🚀</span>
              <span>快速开始</span>
            </div>
            
            <div class="bg-gradient-to-r from-psychology-calm to-psychology-warm rounded-lg p-4 sm:p-5 md:p-6 border border-psychology-primary-20">
              <div class="space-y-3 sm:space-y-4">
                <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
                  <div class="inline-flex items-center rounded-full border px-2.5 sm:px-3 py-1 text-xs sm:text-sm font-semibold bg-psychology-primary-10 text-psychology-primary border-psychology-primary-20 whitespace-nowrap self-start">
                    ⏱️ 预计耗时
                  </div>
                  <span class="text-sm sm:text-base text-gray-700">8-12 分钟</span>
                </div>
                <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
                  <div class="inline-flex items-center rounded-full border px-2.5 sm:px-3 py-1 text-xs sm:text-sm font-semibold bg-psychology-warning-10 text-psychology-warning border-psychology-warning-20 whitespace-nowrap self-start">
                    📝 题目数量
                  </div>
                  <span class="text-sm sm:text-base text-gray-700 break-words">90 道选择题（6维度×15题）</span>
                </div>
                <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
                  <div class="inline-flex items-center rounded-full border px-2.5 sm:px-3 py-1 text-xs sm:text-sm font-semibold bg-psychology-primary-10 text-psychology-primary border-psychology-primary-20 whitespace-nowrap self-start">
                    🎯 测试结果
                  </div>
                  <span class="text-sm sm:text-base text-gray-700 break-words">Holland Code + 6种职业兴趣类型 + 专业推荐</span>
                </div>
                <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
                  <div class="inline-flex items-center rounded-full border px-2.5 sm:px-3 py-1 text-xs sm:text-sm font-semibold bg-psychology-accent-10 text-psychology-accent border-psychology-accent-20 whitespace-nowrap self-start">
                    💡 答题方式
                  </div>
                  <span class="text-sm sm:text-base text-gray-700 break-words">二元选择(喜欢/不喜欢)，根据真实感受选择</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 测评流程 -->
        <div class="card">
          <div class="p-4 sm:p-5 md:p-6">
            <div class="text-xl sm:text-2xl font-semibold flex items-center gap-2 sm:gap-3 mb-4 sm:mb-5 md:mb-6">
              <span class="text-2xl sm:text-3xl">📋</span>
              <span>测试流程</span>
            </div>

            <div class="space-y-3 sm:space-y-4">
              <!-- 步骤1 -->
              <div class="flex items-start gap-3 sm:gap-4 p-3 sm:p-4 bg-psychology-primary-10 rounded-lg border border-psychology-primary-20">
                <div class="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-r from-psychology-primary to-psychology-secondary text-white rounded-full flex items-center justify-center text-base sm:text-lg font-semibold">
                  1
                </div>
                <div class="flex-1 min-w-0">
                  <div class="flex items-center gap-2 mb-1">
                    <span class="text-xl sm:text-2xl flex-shrink-0">📝</span>
                    <h4 class="font-semibold text-sm sm:text-base text-gray-900">开始测试</h4>
                  </div>
                  <p class="text-xs sm:text-sm text-gray-600">点击"开始测试"按钮，阅读简单的测试说明</p>
                </div>
              </div>

              <!-- 步骤2 -->
              <div class="flex items-start gap-3 sm:gap-4 p-3 sm:p-4 bg-psychology-warning-10 rounded-lg border border-psychology-warning-20">
                <div class="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-r from-psychology-warning to-psychology-warning/80 text-white rounded-full flex items-center justify-center text-base sm:text-lg font-semibold">
                  2
                </div>
                <div class="flex-1 min-w-0">
                  <div class="flex items-center gap-2 mb-1">
                    <span class="text-xl sm:text-2xl flex-shrink-0">👤</span>
                    <h4 class="font-semibold text-sm sm:text-base text-gray-900 break-words">填写基本信息</h4>
                  </div>
                  <p class="text-xs sm:text-sm text-gray-600">填写基本信息（昵称、性别、年龄段），帮助获得更精准的分析结果</p>
                </div>
              </div>

              <!-- 步骤3 -->
              <div class="flex items-start gap-3 sm:gap-4 p-3 sm:p-4 bg-psychology-primary-10 rounded-lg border border-psychology-primary-20">
                <div class="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-r from-psychology-primary to-psychology-info text-white rounded-full flex items-center justify-center text-base sm:text-lg font-semibold">
                  3
                </div>
                <div class="flex-1 min-w-0">
                  <div class="flex items-center gap-2 mb-1">
                    <span class="text-xl sm:text-2xl flex-shrink-0">✍️</span>
                    <h4 class="font-semibold text-sm sm:text-base text-gray-900">答题</h4>
                  </div>
                  <p class="text-xs sm:text-sm text-gray-600">回答90道问题，每题使用二元选择（喜欢/不喜欢），根据真实感受选择</p>
                </div>
              </div>

              <!-- 步骤4 -->
              <div class="flex items-start gap-3 sm:gap-4 p-3 sm:p-4 bg-psychology-accent-10 rounded-lg border border-psychology-accent-20">
                <div class="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-r from-psychology-accent to-psychology-secondary text-white rounded-full flex items-center justify-center text-base sm:text-lg font-semibold">
                  4
                </div>
                <div class="flex-1 min-w-0">
                  <div class="flex items-center gap-2 mb-1">
                    <span class="text-xl sm:text-2xl flex-shrink-0">🔍</span>
                    <h4 class="font-semibold text-sm sm:text-base text-gray-900">查看结果</h4>
                  </div>
                  <p class="text-xs sm:text-sm text-gray-600">获得Holland Code、职业兴趣类型和专业推荐报告</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 答题建议 -->
        <div class="card">
          <div class="p-4 sm:p-5 md:p-6">
            <div class="text-xl sm:text-2xl font-semibold flex items-center gap-2 sm:gap-3 mb-4 sm:mb-5 md:mb-6">
              <span class="text-2xl sm:text-3xl">💡</span>
              <span>答题建议</span>
            </div>

            <div class="grid gap-3 sm:gap-4">
              <div class="flex items-start gap-2 sm:gap-3 p-3 sm:p-4 border border-psychology-primary-20 rounded-lg bg-psychology-primary-10">
                <span class="text-xl sm:text-2xl flex-shrink-0">✨</span>
                <div class="min-w-0">
                  <h4 class="font-medium text-sm sm:text-base text-gray-900 mb-1">根据真实感受评分</h4>
                  <p class="text-xs sm:text-sm text-gray-600">不要想"应该"怎样，而是想你"实际上"怎样</p>
                </div>
              </div>

              <div class="flex items-start gap-2 sm:gap-3 p-3 sm:p-4 border border-psychology-info-20 rounded-lg bg-psychology-info-10">
                <span class="text-xl sm:text-2xl flex-shrink-0">🎭</span>
                <div class="min-w-0">
                  <h4 class="font-medium text-sm sm:text-base text-gray-900 mb-1">诚实作答</h4>
                  <p class="text-xs sm:text-sm text-gray-600">选择最符合你真实情况的评分，没有对错之分</p>
                </div>
              </div>

              <div class="flex items-start gap-2 sm:gap-3 p-3 sm:p-4 border border-psychology-secondary-20 rounded-lg bg-psychology-secondary-10">
                <span class="text-xl sm:text-2xl flex-shrink-0">⏱️</span>
                <div class="min-w-0">
                  <h4 class="font-medium text-sm sm:text-base text-gray-900 mb-1">保持专注</h4>
                  <p class="text-xs sm:text-sm text-gray-600">在安静、不被打扰的环境中完成测试，确保可以专注思考</p>
                </div>
              </div>

              <div class="flex items-start gap-2 sm:gap-3 p-3 sm:p-4 border border-psychology-accent-20 rounded-lg bg-psychology-accent-10">
                <span class="text-xl sm:text-2xl flex-shrink-0">🔄</span>
                <div class="min-w-0">
                  <h4 class="font-medium text-sm sm:text-base text-gray-900 mb-1">进度自动保存</h4>
                  <p class="text-xs sm:text-sm text-gray-600">答题过程中可以返回修改，进度会自动保存，可随时继续</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 测试说明 -->
        <div class="card border-psychology-warning-20 bg-psychology-warning-10">
          <div class="p-4 sm:p-5 md:p-6">
            <div class="text-xl sm:text-2xl font-semibold flex items-center gap-2 sm:gap-3 mb-4 sm:mb-5 md:mb-6 text-psychology-warning">
              <span class="text-2xl sm:text-3xl">⚠️</span>
              <span>重要说明</span>
            </div>

            <div class="bg-psychology-warning-10 border border-psychology-warning-20 rounded-lg p-3 sm:p-4">
              <div class="space-y-2.5 sm:space-y-3 text-xs sm:text-sm">
                <div class="flex items-start gap-2">
                  <span class="text-psychology-warning mt-0.5 sm:mt-1 flex-shrink-0">•</span>
                  <span class="text-gray-700"><strong>职业兴趣测试：</strong>这是一个基于霍兰德RIASEC理论的职业兴趣测试，帮助您了解自己的职业倾向，不能替代专业的职业咨询</span>
                </div>
                <div class="flex items-start gap-2">
                  <span class="text-psychology-warning mt-0.5 sm:mt-1 flex-shrink-0">•</span>
                  <span class="text-gray-700"><strong>隐私保护：</strong>所有数据仅存储在您的设备本地，不会上传到任何服务器</span>
                </div>
                <div class="flex items-start gap-2">
                  <span class="text-psychology-warning mt-0.5 sm:mt-1 flex-shrink-0">•</span>
                  <span class="text-gray-700"><strong>结果解读：</strong>测试结果基于6个维度的科学计算，每个人都是独特的，结果仅供参考</span>
                </div>
                <div class="flex items-start gap-2">
                  <span class="text-psychology-warning mt-0.5 sm:mt-1 flex-shrink-0">•</span>
                  <span class="text-gray-700"><strong>多次测试：</strong>可以多次测试，不同时间、不同心情可能会得到不同的结果</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 结果解读 -->
        <div class="card">
          <div class="p-4 sm:p-5 md:p-6">
            <div class="text-xl sm:text-2xl font-semibold flex items-center gap-2 sm:gap-3 mb-4 sm:mb-5 md:mb-6">
              <span class="text-2xl sm:text-3xl">🎯</span>
              <span>结果解读</span>
            </div>

            <div class="space-y-4 sm:space-y-6">
              <!-- 6个维度 -->
              <div>
                <h4 class="font-semibold text-sm sm:text-base text-gray-900 mb-2 sm:mb-3">6个职业兴趣维度（RIASEC）</h4>
                <p class="text-xs sm:text-sm text-gray-600 mb-2 sm:mb-3">测试通过以下6个维度来分析你的职业兴趣：</p>
                <div class="grid sm:grid-cols-2 gap-2.5 sm:gap-3 text-xs sm:text-sm">
                  <div class="p-2.5 sm:p-3 bg-red-50 rounded border border-red-200">
                    <div class="font-medium text-gray-900 mb-1 text-xs sm:text-sm">实际型 (R)</div>
                    <div class="text-gray-600 text-xs">喜欢使用工具、机器进行实际操作</div>
                  </div>
                  <div class="p-2.5 sm:p-3 bg-purple-50 rounded border border-purple-200">
                    <div class="font-medium text-gray-900 mb-1 text-xs sm:text-sm">研究型 (I)</div>
                    <div class="text-gray-600 text-xs">喜欢观察、学习、研究和分析</div>
                  </div>
                  <div class="p-2.5 sm:p-3 bg-amber-50 rounded border border-amber-200">
                    <div class="font-medium text-gray-900 mb-1 text-xs sm:text-sm">艺术型 (A)</div>
                    <div class="text-gray-600 text-xs">喜欢创造性的表达和艺术活动</div>
                  </div>
                  <div class="p-2.5 sm:p-3 bg-cyan-50 rounded border border-cyan-200">
                    <div class="font-medium text-gray-900 mb-1 text-xs sm:text-sm">社会型 (S)</div>
                    <div class="text-gray-600 text-xs">喜欢帮助、教导、服务他人</div>
                  </div>
                  <div class="p-2.5 sm:p-3 bg-green-50 rounded border border-green-200">
                    <div class="font-medium text-gray-900 mb-1 text-xs sm:text-sm">企业型 (E)</div>
                    <div class="text-gray-600 text-xs">喜欢领导、说服、影响他人</div>
                  </div>
                  <div class="p-2.5 sm:p-3 bg-blue-50 rounded border border-blue-200">
                    <div class="font-medium text-gray-900 mb-1 text-xs sm:text-sm">传统型 (C)</div>
                    <div class="text-gray-600 text-xs">喜欢有序、系统、结构化的活动</div>
                  </div>
                </div>
              </div>

              <div class="border-t border-gray-200 my-3 sm:my-4"></div>

              <!-- 结果内容 -->
              <div>
                <h4 class="font-semibold text-sm sm:text-base text-gray-900 mb-2 sm:mb-3">结果包含</h4>
                <div class="space-y-1.5 sm:space-y-2 text-xs sm:text-sm text-gray-600">
                  <div class="flex items-start gap-2">
                    <span class="text-psychology-primary flex-shrink-0 mt-0.5">✓</span>
                    <span>Holland Code（如RIA、SEC等）</span>
                  </div>
                  <div class="flex items-start gap-2">
                    <span class="text-psychology-info flex-shrink-0 mt-0.5">✓</span>
                    <span>6种职业兴趣类型（实际型、研究型、艺术型、社会型、企业型、传统型）</span>
                  </div>
                  <div class="flex items-start gap-2">
                    <span class="text-psychology-secondary flex-shrink-0 mt-0.5">✓</span>
                    <span>六维度雷达图可视化</span>
                  </div>
                  <div class="flex items-start gap-2">
                    <span class="text-psychology-accent flex-shrink-0 mt-0.5">✓</span>
                    <span>维度得分条和柱状图</span>
                  </div>
                  <div class="flex items-start gap-2">
                    <span class="text-psychology-warning flex-shrink-0 mt-0.5">✓</span>
                    <span>专业推荐和职业发展建议</span>
                  </div>
                  <div class="flex items-start gap-2">
                    <span class="text-psychology-success flex-shrink-0 mt-0.5">✓</span>
                    <span>详细的职业心理学解读和个性化建议</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- CTA按钮 -->
        <div class="max-w-3xl mx-auto bg-gradient-to-r from-psychology-primary to-psychology-secondary rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-12 text-white shadow-2xl">
          <div class="text-center">
            <div class="text-4xl sm:text-5xl md:text-6xl mb-4 sm:mb-5 md:mb-6">🎯</div>
            <h3 class="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4 px-2">准备发现你的职业兴趣了吗？</h3>
            <p class="text-sm sm:text-base md:text-lg mb-6 sm:mb-7 md:mb-8 opacity-90 max-w-2xl mx-auto px-2">
              通过科学的六维度RIASEC模型，精准评估你的职业兴趣，深入了解你的Holland Code和适合的职业方向
            </p>
            <router-link
              to="/assessment/info"
              class="inline-flex items-center gap-2 px-6 sm:px-7 md:px-8 py-3 sm:py-3.5 md:py-4 bg-white text-psychology-primary rounded-lg font-bold text-base sm:text-lg hover:bg-gray-100 transition-all hover:shadow-xl"
            >
              <span class="text-xl sm:text-2xl">🚀</span>
              <span>开始测试</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" class="sm:w-5 sm:h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14"></path>
                <path d="m12 5 7 7-7 7"></path>
              </svg>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- 回到顶部 -->
    <BackToTop />
  </div>
</template>

<script setup>
import NavBar from '../components/NavBar.vue'
import BackToTop from '../components/BackToTop.vue'
</script>

<style scoped>
.card {
  @apply bg-white rounded-xl shadow-md border border-gray-200;
}
</style>